import ApiService from "../ApiService";
const {REACT_APP_REST_ENDPOINT} = process.env;

export default class Agenzie {

    static getAllAgenzie = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/agenzie`;
        return ApiService.getRudeRequest(url);
    }

    static getAgenzieByParams = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/agenzie/find`;
            ApiService.postRudeRequest(resolve, reject, url, params)
        });
      };  

    static createAgenzia = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/agenzie/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static deleteAgenzia = (id) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/agenzie/delete`;
            ApiService.delete(resolve, reject, url, id)
        });
    }

    static updateAgenzia = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/agenzie/update`;
            ApiService.putRequest(resolve, reject, url, data)
        });
    }
}